var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-play-button_svg__filter0_b_925_39821)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    stroke: "#C1C2C3",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 39.134a1 1 0 010 1.732L36 48.66a1 1 0 01-1.5-.866V32.206a1 1 0 011.5-.866l13.5 7.794z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "video-play-button_svg__filter0_b_925_39821",
    x: -40,
    y: -40,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_925_39821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_925_39821",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfYl85MjVfMzk4MjEpIj4KPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8Y2lyY2xlIGN4PSI0MCIgY3k9IjQwIiByPSIzNyIgc3Ryb2tlPSIjQzFDMkMzIiBzdHJva2Utd2lkdGg9IjYiLz4KPC9nPgo8cGF0aCBkPSJNNDkuNSAzOS4xMzRDNTAuMTY2NyAzOS41MTg5IDUwLjE2NjcgNDAuNDgxMSA0OS41IDQwLjg2NkwzNiA0OC42NjAzQzM1LjMzMzMgNDkuMDQ1MiAzNC41IDQ4LjU2NCAzNC41IDQ3Ljc5NDJMMzQuNSAzMi4yMDU4QzM0LjUgMzEuNDM2IDM1LjMzMzMgMzAuOTU0OCAzNiAzMS4zMzk3TDQ5LjUgMzkuMTM0WiIgZmlsbD0iYmxhY2siLz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfYl85MjVfMzk4MjEiIHg9Ii00MCIgeT0iLTQwIiB3aWR0aD0iMTYwIiBoZWlnaHQ9IjE2MCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVHYXVzc2lhbkJsdXIgaW49IkJhY2tncm91bmRJbWFnZUZpeCIgc3RkRGV2aWF0aW9uPSIyMCIvPgo8ZmVDb21wb3NpdGUgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9ImluIiByZXN1bHQ9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXJfOTI1XzM5ODIxIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl85MjVfMzk4MjEiIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgVideoPlayButton as ReactComponent };